import React from "react";
import CreativeProjectCard from "../../components/CreativeProjectCard/CreativeProjectCard";
import { SanityLandingPageCardsContentBlock } from "../../model/landing-page";
import { Col, Row } from "../Grid";
import LandingPageSectionCard from "../LandingPageSectionCard/LandingPageSectionCard";
import ProjectsCarousel from "../ProjectsCarousel/ProjectsCarousel";
import SpacedSection from "../SpacedSection/SpacedSection";
import styles from "./LandingPageCardsContentBlock.module.scss";

interface LandingPageCardsContentBlockProps {
  value: SanityLandingPageCardsContentBlock;
}

const LandingPageCardsContentBlock = ({
  value: { cards, content }
}: LandingPageCardsContentBlockProps) => (
  <SpacedSection>
    <div className={styles.mask}>
      <Row justify="center">
        <Col sm={6} className={styles.content}>
          <LandingPageSectionCard content={content} />
        </Col>
      </Row>
      <Row>
        <Col>
          <ProjectsCarousel className={styles.carousel}>
            {cards.map(d => (
              <CreativeProjectCard
                key={d._id}
                className={styles.slide}
                document={d}
              />
            ))}
          </ProjectsCarousel>
        </Col>
      </Row>
    </div>
  </SpacedSection>
);

export default LandingPageCardsContentBlock;
